module.exports = __webpack_public_path__ + "assets/img/922187.964a6058.jpg";